<template>
  <div class="pa-0">
    <vue-element-loading :active="loading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32" spinner="bar-fade-scale" />
    
    <v-snackbar v-model="showSnackbar" :color="snackbarColor" right bottom>
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12>
        <!-- <v-card-title class="elevation-0 px-0 pl-8">
          <span class="itemHeading" style="color: #005f32">LATE ARRIVAL PENALTY</span>
        </v-card-title> -->

        <v-layout wrap justify-start pa-0 pa-xs-0 pa-sm-2 pa-md-5 pa-lg-5 pa-xl-5>
          <v-flex xs12>
            <v-card class="elevation-2 rounded-lg overflow-hidden">
              <v-card-title class="white--text justify-center py-3" style="background-color: #005f32; font-family: 'KumbhBold' !important; font-size: 18px;">
                ADD MEMBERS TO EXCLUDE LIST OF LATE ARRIVAL PENALTY
              </v-card-title>

              <v-card-text class="pt-6">
                <v-layout wrap align-center mb-4>
                  <v-flex xs12 sm8>
                    <span class="kumbhRegular" style="font-size: 15px; color: #666;">
                      Search and select members to add to the exclude list.
                    </span>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Employees"
                      single-line
                      hide-details
                      outlined
                      dense
                      class="rounded-pill mt-2 mt-sm-0"
                      color="#005f32"
                      clearable
                      @keyup.enter="fetchEmployees"
                      @click:append="fetchEmployees"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-data-table
                  :headers="headers"
                  :items="employeeList"
                  class="elevation-0 custom-penalty-table"
                  hide-default-footer
                  mobile-breakpoint="0"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="!isExcluded(item)"
                      color="#005f32"
                      dark
                      small
                      class="rounded-pill px-4 text-none"
                      style="font-family: 'KumbhBold' !important;"
                      @click="addMember(item)"
                    >
                      <v-icon left size="18">mdi-plus-circle</v-icon>
                      Add Member
                    </v-btn>
                    <v-chip
                      v-else
                      color="orange darken-1"
                      dark
                      small
                      class="rounded-pill px-4 kumbhBold"
                      style="height: 28px; min-width: 125px; justify-content: center; font-size: 13px;"
                    >
                      Already Excluded
                    </v-chip>
                  </template>
                </v-data-table>

                <div class="text-center pt-6">
                  <v-pagination
                    v-model="page"
                    :length="pageLength"
                    @input="fetchEmployees"
                    color="#005f32"
                    circle
                    :total-visible="7"
                  ></v-pagination>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "lateArrivalPenaltyExcludeAdd",
  data() {
    return {
      loading: false,
      search: "",
      employeeList: [],
      page: 1,
      limit: 15,
      pageLength: 0,
      showSnackbar: false,
      snackbarMsg: "",
      snackbarColor: "black",
      headers: [
        { text: "Employee ID", value: "employeeId", align: "start", class: "font-weight-bold" },
        { text: "Name", value: "name", class: "font-weight-bold" },
        { text: "Position", value: "position", class: "font-weight-bold" },
        { text: "Status/Actions", value: "actions", sortable: false, align: "center", class: "font-weight-bold" },
      ],
      excludedEmployeeIds: [],
      timeout: null,
    };
  },
  watch: {
    page() {
      this.fetchEmployees();
    },
    search() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.page === 1) {
          this.fetchEmployees();
        } else {
          this.page = 1;
        }
      }, 500);
    },
  },
  mounted() {
    this.fetchExcludedEmployeeIds();
  },
  methods: {
    fetchExcludedEmployeeIds() {
      this.loading = true;
      axios({
        method: "GET",
        url: "/late-arrival-penalty/config",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const data = response.data.data || [];
        // Extract the employee IDs from the exclude list config
        this.excludedEmployeeIds = data.map(record => {
          // Check for common patterns for populated references or raw IDs
          if (record.employeeId && typeof record.employeeId === 'object') return record.employeeId._id;
          return record.employeeId || record.empId; // Backend might use empId or employeeId
        }).filter(id => !!id);
        
        this.fetchEmployees();
      })
      .catch((err) => {
        console.error("Failed to fetch excluded IDs:", err);
        this.fetchEmployees();
      });
    },
    fetchEmployees() {
      this.loading = true;
      axios({
        url: "/employees/getalllist",
        method: "GET",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: {
          keyword: this.search,
          page: this.page,
          limit: this.limit,
        },
      })
      .then((response) => {
        if (response.data && response.data.data) {
          // Format data to match our headers
          this.employeeList = (response.data.data || []).map(emp => ({
            id: emp._id,
            employeeId: emp.employeeId || emp.id || emp.employeeid || "N/A",
            name: emp.name,
            position: emp.position || (emp.positionid && emp.positionid.name) || (emp.positionid && emp.positionid[0] && emp.positionid[0].name) || (emp.positionName) || "N/A"
          }));
          this.pageLength = Math.ceil((response.data.length || 0) / (response.data.limit || this.limit));
        } else if (Array.isArray(response.data)) {
          // Fallback if response.data is directly the array
          this.employeeList = response.data.map(emp => ({
            id: emp._id,
            employeeId: emp.employeeId || emp.id || emp.employeeid || "N/A",
            name: emp.name,
            position: emp.position || (emp.positionid && emp.positionid.name) || (emp.positionid && emp.positionid[0] && emp.positionid[0].name) || (emp.positionName) || "N/A"
          }));
          this.pageLength = 1;
        } else {
          this.toast("No employees found or failed to load", "error");
        }
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
        this.toast("Failed to load employee list", "error");
      });
    },
    isExcluded(item) {
      if (!this.excludedEmployeeIds || !this.excludedEmployeeIds.length) return false;
      // Check both database _id (item.id) and display employeeId (WTI-XXX)
      return this.excludedEmployeeIds.includes(item.id) || this.excludedEmployeeIds.includes(item.employeeId);
    },
    addMember(item) {
      this.loading = true;
      axios({
        method: "POST",
        url: "/late-arrival-penalty/config/add",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: {
          employeeId: item.id
        }
      })
      .then((response) => {
          if (response.data.status || response.data.msg.includes("success")) {
            this.toast("Member added successfully", "success");
            // Add to locally tracked list to avoid refreshing everything
            this.excludedEmployeeIds.push(item.id);
          } else {
            this.toast(response.data.msg || "Failed to add member", "error");
          }
          this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
        this.toast(err.response?.data?.msg || "Failed to add member", "error");
      });
    },
    toast(msg, type = "success") {
      this.snackbarMsg = msg;
      this.snackbarColor = type === "success" ? "#005f32" : "error";
      this.showSnackbar = true;
    }
  }
};
</script>

<style scoped>
.itemHeading {
  font-family: 'KumbhBold' !important;
  font-size: 22px;
}
.kumbhBold {
  font-family: 'KumbhBold' !important;
}
.kumbhRegular {
  font-family: 'KumbhRegular' !important;
}
.custom-penalty-table >>> thead {
  background-color: #f5f5f5;
}
.custom-penalty-table >>> th {
  font-family: 'KumbhBold' !important;
  font-size: 15px !important;
  color: #000 !important;
  border-bottom: 2px solid #005f32 !important;
}
.custom-penalty-table >>> td {
  font-family: 'KumbhMedium' !important;
  font-size: 15px !important;
  padding: 12px 16px !important;
}
</style>
